import React from "react";
import { Card } from "antd";
import { Link } from "react-router-dom";
import { Launch, WorkspacePremium } from "@mui/icons-material";
import { useSelector } from "react-redux";

function SubscriptionDetail() {
  const user = useSelector((state) => state.UserReducer.profile);

  const statusKey = user?.is_subscribed
    ? "active"
    : user?.free_trial
    ? "free-trial"
    : "inactive";

  const statusLabel =
    statusKey === "active"
      ? "Active"
      : statusKey === "free-trial"
      ? "Free trial"
      : "Inactive";

  const ctaLabel = user?.is_subscribed ? "Manage subscription" : "View plans";

  return (
    <Card
      className={`card-box profile-section subscription-card subscription-card--${statusKey}`}
    >
      <div className="profile-section__header">
        <div className="profile-section__icon">
          <WorkspacePremium />
        </div>
        <div className="profile-section__copy">
          <h3 className="card-title">Subscription</h3>
          <span
            className={`subscription-card__status subscription-card__status--${statusKey}`}
          >
            {statusLabel}
          </span>
        </div>
        <Link to="/subscription" className="subscription-card__cta">
          {ctaLabel}
          <Launch />
        </Link>
      </div>
    </Card>
  );
}

export default SubscriptionDetail;
